import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect, PromiseState } from 'react-refetch';

import PromiseStateContainer from '../../apiAccess/PromiseStateContainer';
import BASE_URL from '../../apiAccess/urls';
import { addIndentToNip, createMultiFoodRows } from '../../util/util';
import MultiFoodResultTable from './MultiFoodResultTable';

const createCsvHeader = foods => {
  const csvHeader = [
    {label: 'Nutrient', key: 'nutrient'},
    {label: 'Unit', key: 'unit'},
  ];
  foods.forEach((food, i) => {
    csvHeader.push({
      label: food.shortname, key: `food${i + 1}`
    });
  });
  return csvHeader;
};

class MultiFoodNIP extends Component {
  constructor(props) {
    super(props);
    this.renderOnFulfillment = this.renderOnFulfillment.bind(this);
  }

  componentDidMount() {
    const csvHeader = createCsvHeader(this.props.selectedFoods);
    this.props.setCsvHeader(csvHeader);
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.selectedFoods !== nextProps.selectedFoods) {
      const csvHeader = createCsvHeader(nextProps.selectedFoods);
      this.props.setCsvHeader(csvHeader);
    }
  }

  render() {
    const {
      unitFetch, nipComponentSetFetch,
      food1NipFetch, food2NipFetch, food3NipFetch
    } = this.props;
    return (
      <PromiseStateContainer
        ps={PromiseState.all([
          unitFetch, nipComponentSetFetch,
          food1NipFetch, food2NipFetch, food3NipFetch
        ].filter(n => n))}
        onFulfillment={this.renderOnFulfillment}
      />
    );
  }

  renderOnFulfillment([units, nipComponentSet, ...foodNips]) {
    const nipComponents = addIndentToNip(nipComponentSet);

    // combine nip of each food to food objects
    const selectedFoods = this.props.selectedFoods;
    selectedFoods.forEach((food, i) => {
      food.components = foodNips[i];
    });

    const per100g = this.props.per100g;

    const tableData = createMultiFoodRows(nipComponents, selectedFoods, units, per100g);

    return (
      <div className="MultiFoodResult">

        <MultiFoodResultTable
          tableData={tableData}
          selectedFoods={selectedFoods}
          setCsvData={this.props.setCsvData}
          per100g = {per100g}
        />

      </div>
    );
  }
}

MultiFoodNIP.propTypes = {
  unitFetch: PropTypes.instanceOf(PromiseState),
  nipComponentSetFetch: PropTypes.instanceOf(PromiseState),
  food1NipFetch: PropTypes.instanceOf(PromiseState),
  food2NipFetch: PropTypes.instanceOf(PromiseState),
  food3NipFetch: PropTypes.instanceOf(PromiseState),
  selectedFoods: PropTypes.array,
  per100g: PropTypes.bool.isRequired,
  setCsvHeader: PropTypes.func.isRequired,
  setCsvData: PropTypes.func.isRequired,
};

const fetch = props => {
  if (!props.selectedFoods) { return null; } // don't fetch
  let fetchObject = {
    unitFetch: `${BASE_URL}/unit`,
    nipComponentSetFetch: `${BASE_URL}/component/set/1`,
  };
  props.selectedFoods.forEach((food, i) => {
    const query = food.serving_size_value ? `?amount=${food.serving_size_value}&` : '?';
    fetchObject[`food${i + 1}NipFetch`] = `${BASE_URL}/fiav/food/${food.recordid}${query}comp_group_id=1`;
  });
  return fetchObject;
};

export default connect(fetch)(MultiFoodNIP);



// WEBPACK FOOTER //
// ./src/components/search/multiFood/MultiFoodNIP.js